import { render } from "./PasswordLogin.vue?vue&type=template&id=42116dd1&scoped=true&ts=true"
import script from "./PasswordLogin.vue?vue&type=script&setup=true&lang=ts"
export * from "./PasswordLogin.vue?vue&type=script&setup=true&lang=ts"

import "./PasswordLogin.vue?vue&type=style&index=0&id=42116dd1&lang=scss&scoped=true"

import exportComponent from "/Users/luoke/Desktop/新开发代码_git/h5-jalalive/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42116dd1"],['__file',"src/views/me/PasswordLogin.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "42116dd1"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('42116dd1', __exports__)) {
    console.log('reload')
    api.reload('42116dd1', __exports__)
  }
  
  module.hot.accept("./PasswordLogin.vue?vue&type=template&id=42116dd1&scoped=true&ts=true", () => {
    console.log('re-render')
    api.rerender('42116dd1', render)
  })

}


export default __exports__